<template>
<div>
  <Grid name="modaldealersGrid" ref="modaldealersGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
export default {
  name: 'Client',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'dealersnew',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Selecionar',
          click: this.selectItem
        }
      }, {
        field: 'name',
        title: 'Name'
      }, {
        field: 'code',
        title: 'Código'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    selectItem(e) {
      e.preventDefault()
      var grid = this.$refs.modaldealersGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('select-item', {
        item: dataItem
      })
    }
  }
}
</script>
